<template>
</template>

<script>

	export default {
		name: 'DrawLayer',
		computed: {
			drawLayer: {
				get() { return this.$store.state.map.drawLayer; },
				set(value) { this.$store.commit('set_map', {drawLayer: value}); }
			},
			overlayLayer: {
				get() { return this.$store.state.map.overlayLayer; },
				set(value) { this.$store.commit('set_map', {overlayLayer: value}); }
			},
			layers: {
				get() { return this.$store.state.map.layers; },
				set(value) { this.$store.commit('set_map', {layers: value}); }
			},
			styles: {
				get() { return this.$store.state.styles; },
				set(value) { this.$store.commit('set_style', style); }
			},
			map() { return this.$store.state.map.map },
			zone_types() { return this.$config['zone_types']},
			mode() { return this.$store.state.mode },
			zones() {return this.$store.state.zones}
		},
		mounted() {
			this.init()
		},
		methods: {
			init() {

				this.$set(this.styles, 'selected', new ol.style.Style({
					'fill': new ol.style.Fill({color: 'rgba(0,255,255,0.4)'}),
					'stroke': new ol.style.Stroke({color: 'rgba(0,0,0,1)'})
				}));

				this.$set(this.styles, 'default', new ol.style.Style({
					'fill': new ol.style.Fill({color: 'rgba(255,255,255,0.4)'}),
					'stroke': new ol.style.Stroke({color: 'rgba(255,255,255,1)'})
				}));

				this.$set(this.styles, 'default-line', new ol.style.Style({
					'stroke': new ol.style.Stroke({color: 'rgba(255,255,255,1)', width: 4})
				}));

				this.$set(this.styles, 'path', new ol.style.Style({
					'stroke': new ol.style.Stroke({color: 'rgba(100,255,0,1)', width: 4}),
					'zIndex': 999
				}));

				for (let i in this.zone_types) {
					this.$set(this.styles, i, new ol.style.Style({
						'fill': new ol.style.Fill({color: this.zone_types[i].color}),
						'stroke': new ol.style.Stroke({color: this.zone_types[i].border || 'rgba(255,255,255,0.8)', width: this.zone_types[i].border_width || 1}),
						//opacity: '0.5',
						zIndex: 0
					}));

					this.$set(this.styles, i+'-line', new ol.style.Style({
						'stroke': new ol.style.Stroke({color: this.zone_types[i].color, width: 4}),
						//opacity: '0.5',
						zIndex: 0
					}));
				}

				this.drawLayer = new ol.source.Vector({
					wrapX: false,
					updateWhileAnimating: true,
					updateWhileInteracting: true
				});
				var layer = new ol.layer.Vector({
					source: this.drawLayer,
					style: this.setZoneStyle
				})
				this.layers.push(layer);
				this.map.addLayer(layer);

				this.overlayLayer = new ol.source.Vector({});
				this.map.addLayer(new ol.layer.Vector({
					source: this.overlayLayer
				}));

			},
			setZoneStyle: function (feature, resolution) {

				if (feature.type == 'path') return this.styles['path'];

				let zone = this.zones[feature.id];
				if (!zone) return this.styles['default'];
				let type = feature.type ? feature.type : 'default'
				type += (zone.tool == 'MultiLineString' || zone.tool == 'LineString') ? '-line' : '';
				var style = type ? (this.styles[type] || this.styles['default']) : this.styles['default'];

				return style;
			}
		}
	}
</script>
